import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/shared/ui/atoms';
import { CustomButton } from '@/shared/ui/molecules';
import { useTranslations } from 'next-intl';
import { DirectionIcon } from '@/shared/ui/atoms';
import { useLocale } from 'next-intl';
import { getHospitalAnalysisDisplayLabel } from '@/entities/hospital/lib/analysis-label-localization';
interface FilterTreatmentButtonProps {
  handleClickOpenReviewFilterModal: (type: "treatmentCase" | "detail") => void;
  subject: string;
  hasSubjectsAnalysisList: boolean;
}
const FilterTreatmentButton = t0 => {
  const $ = _c(16);
  const {
    handleClickOpenReviewFilterModal,
    subject,
    hasSubjectsAnalysisList: t1
  } = t0;
  const hasSubjectsAnalysisList = t1 === undefined ? false : t1;
  const t = useTranslations();
  const locale = useLocale();
  let t2;
  if ($[0] !== locale || $[1] !== subject) {
    t2 = subject ? getHospitalAnalysisDisplayLabel(subject, locale) : null;
    $[0] = locale;
    $[1] = subject;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const displaySubject = t2;
  if (!hasSubjectsAnalysisList) {
    return null;
  }
  let t3;
  if ($[3] !== handleClickOpenReviewFilterModal) {
    t3 = () => handleClickOpenReviewFilterModal("treatmentCase");
    $[3] = handleClickOpenReviewFilterModal;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== displaySubject || $[6] !== t) {
    t4 = displaySubject || t("filter.subject");
    $[5] = displaySubject;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="min-w-0 flex-1 truncate">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DirectionIcon size={16} className="shrink-0 text-gray-400" strokeWidth="1.3" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <Typography size={14} lineHeight={22} whitespace="nowrap" className="flex min-w-0 items-center gap-1 rounded-full bg-gray-700 py-1.5 pl-3 pr-2.5 text-white">{t5}{t6}</Typography>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <CustomButton className="min-w-0 overflow-hidden text-left" onClick={t3}>{t7}</CustomButton>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default FilterTreatmentButton;